'use client';

import ApyBreakdownTooltipV2 from 'src/components/Tooltip/ApyBreakdownTooltipV2';
import { useApyBreakdownTooltipData } from 'src/hooks/useApyBreakdownTooltipData';
import { BalanceRowData } from './types';

interface EarningApyCellProps {
	row: BalanceRowData;
}

export function EarningApyCell({ row }: EarningApyCellProps) {
	const { spotMarketIndex } = row;
	const apyData = useApyBreakdownTooltipData(spotMarketIndex);

	const displayApy =
		!isFinite(apyData.deposit.totalApy) || apyData.deposit.totalApy > 1000
			? '> 1,000%'
			: `${apyData.deposit.totalApy.toFixed(2)}%`;

	return (
		<ApyBreakdownTooltipV2
			apyChunks={apyData.deposit.chunks}
			showTooltip={apyData.deposit.showTooltip}
		>
			<span className="text-text-positive-green-button">{displayApy}</span>
		</ApyBreakdownTooltipV2>
	);
}
